import createApiClient from '../utils/apiClient';

const api = createApiClient();

export interface CreateDevicePayload {
  device_name?: string;
  device_type?: string;
  locked_stream?: {
    channelID: string;
    platform: 'twitch' | 'youtube' | 'kick';
  };
}

export interface CreatedDevice {
  id: number;
  user_id: number | null;
  assigned_email?: string | null;
  device_hash: string;
  device_name: string | null;
  device_type: string | null;
  created_at: string;
  updated_at: string;
}

const adminService = {
  createDevice: async (payload: CreateDevicePayload) => {
    const response = await api.post<{ message: string; device: CreatedDevice }>(
      `/admin/devices/create`,
      payload
    );
    return response.data.device;
  },

  getAllDevices: async () => {
    const response = await api.get<{ devices: CreatedDevice[] }>(
      `/admin/devices`
    );
    return response.data.devices;
  },
};

export default adminService;
